// created by Igor Zakolodyazhnyi
export class UI {
  initUI () {
    const _this = this
    window.setTimeout(function () {
      _this.createSelects()
    }, 1)
  }

  createSelects (val) {
    const clf = function (elmnt) {
      var x; var y; var i; var arrNo = []
      x = document.getElementsByClassName('select-items')
      y = document.getElementsByClassName('select-selected')

      for (i = 0; i < y.length; i++) {
        if (elmnt === y[i]) {
          arrNo.push(i)
        } else y[i].classList.remove('select-arrow-active')
      }

      for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) x[i].classList.add('select-hide')
      }
    }

    var x, i, j, selElmnt, a, b, c
    x = document.querySelectorAll('.input__select')
    const xl = x.length

    for (i = 0; i < xl; i++) {
      selElmnt = x[i].querySelector('select')
      if (selElmnt === null) continue
      a = selElmnt.nextElementSibling
      if (a === null) continue
      b = document.createElement('div')
      b.setAttribute('class', 'select-items select-hide')

      for (j = 0; j < selElmnt.length; j++) {
        if (selElmnt.selectedIndex === j && selElmnt.options[j].classList.contains('select-placeholder')) {
          a.classList.add('with-placeholder')
          a.innerHTML = selElmnt.options[j].innerHTML
          continue
        }

        if (typeof val === 'object' && val[selElmnt.id] === selElmnt.options[j].value) {
          a.classList.remove('with-placeholder')
        }

        c = document.createElement('div')
        if (selElmnt.options[j].getAttribute('data-style') !== null) {
          c.setAttribute('style', selElmnt.options[j].getAttribute('data-style'))
        }
        c.setAttribute('data-value', selElmnt.options[j].value)
        c.innerHTML = selElmnt.options[j].innerHTML

        c.addEventListener('click', function (e) {
          var y, i, k, s, h
          s = this.parentNode.parentNode.firstElementChild
          h = this.parentNode.previousElementSibling
          for (i = 0; i < s.length; i++) {
            if (s.options[i].innerHTML === this.innerHTML && s.options[i].innerHTML !== h.innerHTML) {
              s.selectedIndex = i
              h.classList.remove('with-placeholder')
              y = this.parentNode.getElementsByClassName('same-as-selected')
              for (k = 0; k < y.length; k++) y[k].removeAttribute('class')
              this.className = 'same-as-selected'

              if ('createEvent' in document) {
                var evt = document.createEvent('HTMLEvents')
                evt.initEvent('change', false, true)
                s.dispatchEvent(evt)
              } else s.fireEvent('onchange')

              break
            }
          }

          h.click()
        })

        b.appendChild(c)
      }

      x[i].appendChild(b)

      a.addEventListener('click', function (e) {
        e.stopPropagation()
        const all = document.querySelectorAll('.input-error')
        for (let i = 0; i < all.length; i++) all[i].classList.remove('input-error')
        if (this.previousElementSibling.disabled) {
          this.previousElementSibling.classList.add('input-error')
          return
        }

        clf(this)
        this.nextElementSibling.classList.toggle('select-hide')
        this.classList.toggle('select-arrow-active')
      })
    }

    document.addEventListener('click', clf)
  }
}
